/**
 * 路由主文件
 */

import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import NPprogress from './middlware/NProgress';
import { stringifyQuery, parseQuery } from "@/utils/utils";
Vue.use(Router);

const router = new Router({
  // base: '/resources',
  // mode: 'history',
  routes,
  // stringifyQuery,
  // parseQuery
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach(NPprogress.start);
router.afterEach(NPprogress.done);

export default router;
